/* eslint-disable no-console */
import request from 'superagent';
import Bugsnag from 'helpers/bugsnag.js';
import superagentCache from 'superagent-cache';

const cacheModuleConfig = { storage: 'local' };
superagentCache(request, cacheModuleConfig);

const Config = require('Config');
 // Helpers
const base = `${Config.svcFeed.root}/`;
const contentType = { 'Content-Type': 'application/x-www-form-urlencoded' };

let csrfToken;

export const fetchGen = root => ({
  setCsrfToken: (token) => {
    csrfToken = token;
  },

  get: url => request
    .get(root + url)
    .expiration(600) // 10 minutes before cache keys refresh
    .preventDuplicateCalls()
    .withCredentials()
    .set(contentType)
    .on('error', Bugsnag.notify),
  post: (url, data, options = {}) => {
    const req = request
    .post(root + url)
    .preventDuplicateCalls()
    .send(data || {})
    .withCredentials()
    .set('Process-Data', false)
    .set('X-CSRF-Token', csrfToken)
    .on('error', Bugsnag.notify);
    if (options.contentType) {
      req.set(contentType);
    }
    return req;
  },
  put: (url, data) => request
    .put(root + url)
    .send(data || {})
    .withCredentials()
    .set(contentType)
    .set('X-CSRF-Token', csrfToken)
    .on('error', Bugsnag.notify),
  patch: (url, data) => request
    .patch(root + url)
    .send(data || {})
    .withCredentials()
    .set(contentType)
    .set('X-CSRF-Token', csrfToken)
    .on('error', Bugsnag.notify),
  delete: (url, data) => request
    .delete(root + url)
    .send(data || {})
    .withCredentials()
    .set(contentType)
    .set('X-CSRF-Token', csrfToken)
    .on('error', Bugsnag.notify),

  pruneKey: keyString => {
    const regex = new RegExp(keyString);
    const cookie = localStorage.getItem('cache-module-local-storage') || {};
    const localCache = JSON.parse(cookie);
    const keys = localCache && localCache.db ? Object.keys(localCache.db) : [];
    const matchedKeys = keys.filter(k => regex.test(k));
    if (matchedKeys.length) {
      request.cache.del(matchedKeys, (err, count) => {
        if (err) {
          return new Error('Could not remove keys from cache:', err);
        }
        if (process.env.NODE_ENV === 'development' && count) {
          console.log(`:: Deleted ${count} key${count > 1 ? 's' : ''} from Fetch cache`);
        }
      });
    }
  },
  _module: request.cache,
});

export const fetch = fetchGen(`${base}api/feed`);
export const fetchV1 = fetchGen(`${base}api/v1/blueprint`);
export const fetchV1Base = fetchGen(`${base}api/v1`);

/*
 * In a development setting, it might become useful to access the
 * cache module's built in APIs such as flushing the storage or
 * appending the .forceUpdate() chainable to toggle the cache on/off
 */

window.fetchCache = (() => {
  const setCookie = () => localStorage.setItem('fetchCache', JSON.stringify({ toggled: true, verbose: false }));
  const parseCookie = cookie => JSON.parse(cookie);
  const getCookie = (set = false) => {
    if (localStorage.getItem('fetchCache') === null || set) {
      setCookie();
    }
    return parseCookie(localStorage.getItem('fetchCache'));
  };

  let parsedCookie = getCookie();
  if (Object.keys(parsedCookie).length < 2) {
    parsedCookie = getCookie(true);
  }

  const settings = {
    toggled: parsedCookie.toggled,
    verbose: parsedCookie.verbose,
  };

  if (!settings.toggled && localStorage.getItem('fetchCache')) {
    request.cache.flush();
  }

  const fncOverrideWrap = fn => {
    const ogFnc = request[fn];
    const override = (...args) => ogFnc(args).forceUpdate(!settings.toggled);
    request[fn] = override;
  };

  return {
    settings,
    init: () => {
      /*
        * On init we'll see if the cookie is specifically set off, and if so,
        * ensure the override is performed on the cache
        */
      if (!settings.toggled) {
        fncOverrideWrap('get');
      }
      if (settings.verbose && !request.cache.verbose) {
        request.cache.verbose = true;
      }

      if (settings.verbose) {
        window.fetchCache.status();
      }
    },
    status: () => {
      console.log(`:: Fetch cache toggled: ${settings.toggled ? 'ON' : 'OFF'}`);
      console.log(`:: Fetch cache verbose: ${settings.verbose ? 'ON' : 'OFF'}`);
    },
    flush: () => {
      request.cache.flush();
      console.log(':: Fetch cache has been flushed');
    },
    toggle: () => {
      settings.toggled = !settings.toggled;
      fncOverrideWrap('get');
      localStorage.setItem('fetchCache', JSON.stringify(settings));
      window.fetchCache.status();
      window.fetchCache.flush();
    },
    verbose: () => {
      settings.verbose = !settings.verbose;
      request.cache.verbose = !request.cache.verbose;
      localStorage.setItem('fetchCache', JSON.stringify(settings));
    },
    _module: request.cache,
  };
})();

window.fetchCache.init();
